// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"0590a5ac","353":"273b4a7b","468":"9399c61c","496":"1793e5e9","667":"0187a422"}[chunkId] + ".chunk.js";
};